import { RestClient } from '@/api/rest-client'
import { Pipeline } from '@/api/model/pipeline'
import { Company } from '@/api/model/company'
import { cloneDeep } from 'lodash'
import { Branch } from '@/api/model/branch'
import { MigrationMap } from '@/api/model/migration-map'

export class MigrationMapClient extends RestClient<MigrationMap> {
    collectionName = 'migration_maps'
    parseData = MigrationMap.fromData

    async create(data: MigrationMap): Promise<MigrationMap> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        return super.create(request)
    }

    async startMigration(data: MigrationMap): Promise<MigrationMap> {
        try {
            const response = await this.client.put(`${this.basePath}/${this.collectionName}/${data.id}/start_migration`, data)
            return await this.get(data.id, true)

        } catch (error) {
            this.handleError(error)
        }
    }

    protected handleError(error: any) {
        throw error
    }
}
